export interface Fraction {
  installmentNumber: number;
  baseAmount: number;
  percentageApply: number;
  installmentAmount: number;
  paymentType: string;
}

export const makeEmptyFraction = (): Fraction => ({
  installmentNumber: 0,
  baseAmount: 0,
  installmentAmount: 0,
  percentageApply: 0,
  paymentType: '',
});
